// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"293":"7b265685","945":"302a97e2"}[chunkId] + ".chunk.css";
};